module.exports = __webpack_public_path__ + "static/img/pic-04.195947f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/m/pic-04.png
// module id = BgiE
// module chunks = 1